import { AsyncActions } from '@telstra-connect/standard-actions/';
import { BILLING_LOAD_DD_AGREEMENT } from './action-types';
import { IDDAgreement } from '../state/dd-agreement';

export interface ILoadDDAgreementAction
    extends AsyncActions.IAsyncFetchableAction<BILLING_LOAD_DD_AGREEMENT> {
}

export interface ILoadDDAgreementSuccessAction extends AsyncActions.IAsyncAction<BILLING_LOAD_DD_AGREEMENT> {
    data: IDDAgreement;
}

export type ILoadDDAgreementErrorAction = AsyncActions.IAsyncErrorAction<BILLING_LOAD_DD_AGREEMENT>;

export const loadDDAgreementStart = (): ILoadDDAgreementAction => ({
    status: AsyncActions.AsyncActionState.Initiated,
    type: BILLING_LOAD_DD_AGREEMENT,
    isFetchable: true
});

export const loadDDAgreementSuccess = (data: IDDAgreement): ILoadDDAgreementSuccessAction => ({
    status: AsyncActions.AsyncActionState.Success,
    type: BILLING_LOAD_DD_AGREEMENT,
    data
});

export const loadDDAgreementError = (error: string, errorCode?: string): ILoadDDAgreementErrorAction => ({
    status: AsyncActions.AsyncActionState.Failure,
    type: BILLING_LOAD_DD_AGREEMENT,
    error,
    errorCode
});
